function* delay(time) {
  yield new Promise(resolve => setTimeout(resolve, time));
}

export default delay;
